import React from 'react';
import { useTranslation } from "react-i18next";
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { styled } from '@uhg-abyss/web/tools/styled';

const FooterWrapper = styled('div', {
    padding: '15px',
    margin: '4px',
});

export const Footer = () => {
    const { t } = useTranslation();

    const date = new Date();

    var footerText = t('poweredBySecure');
    var footerBusiness = t('optumCopyright', { year: date.getFullYear() });

    return (
        <FooterWrapper>
            <Layout.Stack alignLayout="center">
                <Text data-testid="footerText" color="$textSecondary">{footerText}</Text>
                <Text data-testid="footerBusiness" color="$textSecondary">{footerBusiness}</Text>
            </Layout.Stack>
        </FooterWrapper>
    );
}